import React from 'react';
import LoadingSpinner from './LoadingSpinner';

export default function RouteFallback() {
  return (
    <div className="mingo-route-fallback">
      <LoadingSpinner label="" />
    </div>
  );
}
